<template>
  <b-modal
    v-model="localShowModal"
    size="lg"
    title="Neuen Tenant erfassen"
  >
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />

    <!-- Formular zur Eingabe der Tenant-Daten -->
    <u-loader v-if="isLoading" />

    <div v-else>
      <b-row>
        <b-col :cols="firstColumnWidth">
          <label class="font-weight-bold mt-2">Tenants</label>
        </b-col>

        <b-col cols="9">
          <v-form
            ref="tenantSelect"
            v-model="tenantSelectForm"
          >
            <v-select
              v-model="tenant.tenantId"
              :items="tenantOptions"
              :rules="[rules.required]"
              class="pt-0 mt-0"
              item-text="bezeichnung"
              item-value="id"
              label="Tenant"
              @change="handleTenantChange"
            />
            <error-message
              v-if="!tenant.tenantId"
              error-message="Ein Tenant muss ausgewählt werden"
            />
          </v-form>
        </b-col>
      </b-row>
      <hr>
      <!-- Anzeigename Section -->
      <tenant-multi-lang-form-section
        :can-user-edit="true"
        :first-column-width="firstColumnWidth"
        :model="tenant.publicationContents"
        :required="true"
        field="value"
        label="Anzeigename"
      />
      <hr>
      <!-- Kurzname Section -->
      <tenant-multi-lang-form-section
        :can-user-edit="true"
        :first-column-width="firstColumnWidth"
        :model="tenant.publicationContents"
        field="shortName"
        label="Kurzname"
      />
      <hr>
      <!-- Publikationsdatum Section -->
      <b-row>
        <b-col :cols="firstColumnWidth">
          <label
            class="font-weight-bold"
            for="publikationsdatum"
          >Publikationsdatum</label>
        </b-col>
        <b-col cols="9">
          <v-flex
            md6
            sm12
          >
            <u-date-picker
              id="tenantPublishingDateInput_Create"
              v-model="tenant.publicationDate"
              label="Publikationsdatum"
            />
          </v-flex>
        </b-col>
      </b-row>
      <hr>
      <!-- Gültig ab Section -->
      <b-row>
        <b-col :cols="firstColumnWidth">
          <label
            class="font-weight-bold"
            for="gueltigab"
          >Gültig ab</label>
        </b-col>
        <b-col cols="9">
          <v-flex
            md6
            sm12
          >
            <u-date-picker
              id="'tenantValidFromInput_Create"
              v-model="tenant.validFrom"
              label="Gültig ab"
            />
          </v-flex>
        </b-col>
      </b-row>
    </div>

    <template #modal-footer>
      <div class="container-fluid p-0">
        <div class="row">
          <div class="ml-auto col-auto">
            <v-btn
              :disabled="
                !tenant.tenantId ||
                  !areAllValuesPresent(tenant.publicationContents)
              "
              :loading="isLoading"
              color="success"
              @click="handleSave"
            >
              <i class="fas fa-save mr-2" /> Speichern
            </v-btn>
            <v-btn
              color="secondary"
              @click="handleCancel"
            >
              <i class="fas fa-ban mr-2" /> Abbrechen
            </v-btn>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import TenantMultiLangFormSection from "@/components/contract/version/tenant/MultiLangFormSection.vue";
import UDatePicker from "@/components/common/UDatePicker.vue";
import { AddPublication } from "@/services/contract.tenants.service";
import ErrorMessage from "@/components/contract/version/tenant/ErrorMessage.vue";
import { GetVersionInformation } from "@/services/contract.service";

export default {
  name: "TenantCreateModal",
  components: { ErrorMessage, UDatePicker, TenantMultiLangFormSection },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    aviableTenants: {
      type: Array,
      default: () => [],
    },
    versionId: {
      type: Number,
      default: 0,
    },
    contractId: { type: String, default: "" },
    versionNumber: {
      type: Number,
      default: 0,
    },
    langs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localShowModal: this.showModal,
      isLoading: false,
      firstColumnWidth: 3,
      tenant: {},
      tempdataPubContent: [],
      defaultPubContent: [],
      rules: {
        required: (value) => !!value || "Ein Tenant muss ausgewählt werden",
      },
      errorObject: "",
      tenantSelectForm: false,
    };
  },
  computed: {
    tenantOptions() {
      if (
        this.$IsUserInRole("VertragsmanagementUniaVertragsverantworlich") &&
        !this.$IsUserInRole("VertragsmanagementVerwaltung")
      ) {
        var uniaTenant = this.aviableTenants.find((tenant) => tenant.id === 4);
        if (uniaTenant) {
          return [uniaTenant];
        } else {
          return [];
        }
      }
      return this.aviableTenants;
    },
  },
  watch: {
    showModal(val) {
      this.localShowModal = val; // Beobachtet Änderungen und aktualisiert den lokalen Zustand
    },
    localShowModal(val) {
      if (!val) {
        this.$emit("close-modal"); // Event zum Schliessen des Modals auslösen
      }
    },
  },
  created() {
    this.setTenants();
  },
  methods: {
    handleTenantChange() {
      if (this.tenant.tenantId === 2) {
        this.isLoading = true;
        this.tenant.publicationContents = this.tempdataPubContent;
      } else {
        if (this.tenant.publicationContents !== this.defaultPubContent) {
          this.isLoading = true;
          this.tenant.publicationContents = this.defaultPubContent;
        }
      }
      setTimeout(() => {
        this.isLoading = false;
      }, 100);
    },
    areAllValuesPresent(publicationContents) {
      return publicationContents.every((content) => content.value !== "");
    },
    handleSave() {
      // Logik zum Speichern des neuen Tenants
      this.isLoading = true;

      AddPublication(
        this.tenant,
        () => {
          this.handleSuccess();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    handleCancel() {
      this.resetForm();
      this.closeModal();
    },
    setTenants() {
      this.isLoading = true;

      GetVersionInformation(
        this.contractId,
        this.versionNumber,
        (result) => {
          // Prüfen, ob versionContents vorhanden und nicht leer sind
          if (!result?.versionContents?.length) {
            this.isLoading = false;
            return;
          }

          const publicationContents = this.langs.map((lang) => {
            const matchingContent = result.versionContents.find(
              (content) => content.language === lang.ref,
            );

            const nameShort = matchingContent?.nameShort || "";
            const value = matchingContent?.value || "";

            return {
              id: 0,
              shortName: nameShort,
              publicationId: 0,
              value,
              language: lang.ref,
            };
          });

          this.defaultPubContent = JSON.parse(
            JSON.stringify(publicationContents),
          );
          this.tempdataPubContent = this.langs.map((lang) => {
            const matchingContent = result.versionContents.find(
              (content) => content.language === lang.ref,
            );

            const nameShort = matchingContent?.nameShort || "";
            const tempValue = this.createTempValue(lang.ref, nameShort);

            return {
              id: 0,
              shortName: nameShort,
              publicationId: 0,
              value: tempValue,
              language: lang.ref,
            };
          });

          this.tenant = {
            id: 0,
            versionId: this.versionId,
            publicationDate: "",
            tenantId: 0,
            validFrom: "",
            code: "publicationTitle",
            publicationContents,
          };

          setTimeout(() => {
            this.isLoading = false;
            this.$refs.tenantSelect.validate();
          }, 500);
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
          this.$refs.tenantSelect.validate();
        },
      );
    },

    createTempValue(langRef, nameShort) {
      switch (langRef) {
        case "de-CH":
          return `Personalverleih ${nameShort}`;
        case "fr-CH":
          return `Location de services ${nameShort}`;
        case "it-CH":
          return `Prestito di personale ${nameShort}`;
        default:
          return nameShort;
      }
    },

    resetForm() {
      this.setTenants();
    },
    closeModal() {
      this.$emit("close-modal");
    },
    handleSuccess() {
      this.resetForm();
      this.isLoading = false;
      this.closeModal();
      this.$emit("success");
    },
  },
};
</script>
